import { connect } from 'react-redux';

import { Skeleton, SkeletonProps } from '../../components/Skeleton/Skeleton';
import { State } from '../../typings/state';
import { TStateProps } from '../../typings/utils';

export interface OwnProps {
    height: number;
    cls?: string;
}

export type StateProps = TStateProps<SkeletonProps, OwnProps>;

const mapStateToProps = (state: State): StateProps => {
    const { isGridScrolling } = state.grid;

    return {
        isAnimating: !isGridScrolling
    };
};

export const GridSkeletonContainer = connect<StateProps, {}, OwnProps>(
    mapStateToProps
)(Skeleton);
